import styled from '@emotion/styled'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { fonts } from '../../__styling/settings/fonts'

export const StyledMoreTitle = styled('h2')({
    fontSize: calcRem(18),
    fontFamily: fonts.sevennews.sansSerifCond,
    textTransform: 'uppercase',
    marginBottom: calcRem(18),
})
